import type { UserManagerSettings } from "oidc-client-ts";
import { WebStorageStateStore } from "oidc-client-ts";

export type ProviderId = "authentik" | "keycloak";

// Общая часть конфига — redirect URIs, скоупы, хранилище токенов.
// Все эти настройки одинаковы у любого провайдера; меняется только
// authority + client_id (и scope-список под капабилити IdP).
function commonSettings(): Omit<UserManagerSettings, "authority" | "client_id" | "scope"> {
  return {
    redirect_uri: window.location.origin + "/auth/callback",
    silent_redirect_uri: window.location.origin + "/auth/silent-renew",
    post_logout_redirect_uri: window.location.origin + "/",
    response_type: "code",
    automaticSilentRenew: true,
    loadUserInfo: true,
    // localStorage чтобы refresh страницы / рестарт vite не разлогинивал.
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    stateStore: new WebStorageStateStore({ store: window.localStorage }),
    monitorSession: false,
  };
}

function buildProviders(): Record<ProviderId, UserManagerSettings> {
  const base = commonSettings();
  return {
    authentik: {
      ...base,
      authority:
        import.meta.env.VITE_AUTHENTIK_AUTHORITY ??
        "https://auth.devback.aknaucer.ru/application/o/medtranslate-spa-dev/",
      client_id: import.meta.env.VITE_AUTHENTIK_CLIENT_ID ?? "",
      // Authentik у нас отдаёт стандартный `groups` claim для ролей —
      // его кладут в id_token при scope=openid (без отдельного запроса).
      scope: "openid profile email offline_access",
    },
    keycloak: {
      ...base,
      authority:
        import.meta.env.VITE_KEYCLOAK_AUTHORITY ??
        "https://keycloak.devisfun.ru/realms/medtranslate",
      client_id: import.meta.env.VITE_KEYCLOAK_CLIENT_ID ?? "medtranslate-web",
      scope: "openid profile email offline_access",
    },
  };
}

function resolveActiveProvider(): ProviderId {
  const raw = import.meta.env.VITE_AUTH_PROVIDER;
  if (raw === "keycloak") return "keycloak";
  return "authentik";
}

export const activeProvider: ProviderId = resolveActiveProvider();

export const oidcConfig: UserManagerSettings = buildProviders()[activeProvider];
